import { ANYTHING, CacheScenario, CacheTime, MethodType } from '../models/api/cache';
import { API_ENDPOINT } from './utils.service';

export const incidentsServiceCache: () => CacheScenario[] = (): CacheScenario[] => [
  {
    description: 'method getSubscriptionState, caching subscription state for incidents',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/subscriptions/incidents/all`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      { // IncidentsService.subscribeIncidents or IncidentsService.unsubscribeIncidents
        url: `${API_ENDPOINT}/subscriptions/incidents/all/${ANYTHING}`,
        method: MethodType.POST,
      },
    ],
  },
];
